/* =====================================================================
   Buds Sports US · Scripts communs a tout le site : panier lateral
   Range le 14/10/2026. Prefixe des classes : .bpdp
   ===================================================================== */
/* ==== Panier lateral : message Added, Frequently bought together (deplace depuis snippets/cart-drawer.liquid) ==== */
(function () {
  if (window.bpdpCartInit) return;
  window.bpdpCartInit = true;
  var KEY = 'bpdpAddedAt';
  function mark() { try { sessionStorage.setItem(KEY, String(Date.now())); } catch (e) {} }
  function fresh() { try { return Date.now() - Number(sessionStorage.getItem(KEY) || 0) < 10000; } catch (e) { return false; } }
  window.bpdpMarkAdded = mark;
  document.addEventListener('click', function (e) {
    if (e.target.closest('.single-add-to-cart-button, .bpdp-add2')) mark();
  }, true);
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function syncButton(box) {
    var btn = box.querySelector('.bpdp-fbt__btn');
    var checked = box.querySelectorAll('.bpdp-fbt__cb:checked');
    var sum = 0;
    checked.forEach(function (c) { sum += Number(c.dataset.price || 0); });
    btn.disabled = checked.length === 0;
    btn.textContent = checked.length ? 'Add selected · ' + money(sum) : 'Add selected';
  }
  function showAdded() {
    var drawer = document.getElementById('Cart-Drawer');
    if (!drawer) return;
    var msg = drawer.querySelector('.bpdp-cart-added');
    if (msg) msg.hidden = !fresh();
  }
  /* 14/10/2026 : on relit le panier avant de rafraichir. Avant, la quantite affichee (ancienne) etait renvoyee
     et annulait l'ajout du 2e Rollbag quand il etait coche avec un autre produit. */
  function refreshDrawer() {
    var drawer = document.querySelector('cart-drawer');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (!drawer || typeof drawer.updateQuantity !== 'function') { window.location.reload(); return; }
    fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var first = cart.items && cart.items[0];
        if (!first) { window.location.reload(); return; }
        drawer.updateQuantity(first.key, first.quantity, 1);
      })
      .catch(function () { window.location.reload(); });
  }
  document.addEventListener('change', function (e) {
    var box = e.target.closest('[data-bpdp-fbt]');
    if (box) syncButton(box);
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.bpdp-fbt__btn');
    if (!btn || btn.disabled) return;
    var box = btn.closest('[data-bpdp-fbt]');
    var items = [];
    box.querySelectorAll('.bpdp-fbt__cb:checked').forEach(function (c) { items.push({ id: Number(c.value), quantity: 1 }); });
    if (!items.length) return;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json(); })
      .then(function () { mark(); refreshDrawer(); })
      .catch(function () { btn.disabled = false; btn.textContent = 'Add selected'; });
  });
  function watch() {
    var drawer = document.getElementById('Cart-Drawer');
    if (!drawer) return;
    showAdded();
    new MutationObserver(showAdded).observe(drawer, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();
